import React, { CSSProperties } from "react";
import { getDockPositionStyles, isSmartPhone } from "../utils/utils";
import { getThemeConfig, getThemeDesign } from "../theme/theme.manager";

/**
 * チャットボタンのプロパティ
 */
interface ChatButtonProps {
  onClick: () => void;
  leftOrRight: string;
  offset_x: number;
  offset_y: number;
  isOpen?: boolean;
}

/**
 * チャットボタンコンポーネント
 * チャットウィンドウを開くためのフローティングボタン
 */
const ChatButton: React.FC<ChatButtonProps> = ({
  onClick,
  leftOrRight,
  offset_x,
  offset_y,
  isOpen = false,
}) => {
  // チャットボタンの位置
  const themeDesign = getThemeDesign();
  const positionStyles = getDockPositionStyles(
    leftOrRight,
    offset_x,
    offset_y,
    false,
    themeDesign.alignment,
    themeDesign.banner_margin_horizontal,
    themeDesign.banner_margin_vertical,
  );
  const themeConfig = getThemeConfig();
  const isMobile = isSmartPhone();
  // useMobileBannerについて、version 1.2までは使用していない
  // const useMobileBanner =
  //   isMobile && themeConfig.isBannerM && themeConfig.bannerMUrl;
  // const bannerSrc = useMobileBanner
  //   ? themeConfig.bannerMUrl
  //   : themeConfig.buttonInitIcon;
  // const bannerWidth = useMobileBanner
  //   ? (themeConfig.bannerMWidth ?? 0)
  //   : (themeConfig.bannerWidth ?? 0);
  const bannerSrc = ((themeConfig.isBannerM ?? false) && isMobile) 
    ? themeConfig.bannerMUrl 
    :themeConfig.buttonInitIcon;
  const bannerWidth = isMobile
    ? (themeConfig.bannerMWidth ?? 0)
    : (themeConfig.bannerWidth ?? 0);
  const visible = !isOpen;
  const slideOutDistance = 120;
  const leftOrRightStyle = themeDesign.alignment ?? leftOrRight;
  const slideTransform = visible
    ? "translateX(0)"
    : leftOrRightStyle === "right"
      ? `translateX(${slideOutDistance}px)`
      : `translateX(-${slideOutDistance}px)`;

  const buttonStyles: CSSProperties = {
    ...positionStyles,
    transform: slideTransform,
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? "auto" : "none",
  };

  const iconStyles: CSSProperties =
    bannerWidth > 0 ? { width: `${bannerWidth}px`, height: "auto" } : {};

  return (
    <button
      onClick={onClick}
      className="pathbee-chat-button bg-transparent border-0 p-0 transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 overflow-visible"
      style={buttonStyles}
      aria-label="チャットボタン"
      aria-expanded={isOpen}
      type="button"
    >
      <img
        src={bannerSrc}
        alt="チャット"
        className="pathbee-chat-button-icon"
        style={iconStyles}
      />
    </button>
  );
};

export default ChatButton;
